module.exports = __webpack_public_path__ + "static/img/dj.1b0a1070.svg";